import { UUID } from '../../../core/context/uuid/entity';
import { Entity } from '../../../core/context/entity';

export enum CommentStatus {
    Accepted = 'accepted',
    Rejected = 'rejected',
    Open = 'open',
}

interface ThreatVectorCommentProps {
    id: string;
    operation?: boolean;
    content: string;
    authorId: string;
    date: Date;
    status: CommentStatus;
    threatVectorId: string;
}

export class ThreatVectorComment extends Entity {
    operation?: boolean;
    content: string;
    authorId: string;
    date: Date;
    status: CommentStatus;
    threatVectorId: string;

    constructor({
        id,
        content,
        date,
        operation,
        status,
        authorId,
        threatVectorId,
    }: ThreatVectorCommentProps) {
        super({ id });
        this.content = content;
        this.date = date;
        this.operation = operation;
        this.status = status;
        this.authorId = authorId;
        this.threatVectorId = threatVectorId;
    }

    static new(
        props: Omit<ThreatVectorCommentProps, 'id'>,
    ): ThreatVectorComment {
        const uuid = new UUID();
        return new ThreatVectorComment({
            id: uuid.toString(),
            ...props,
        });
    }
}
